import { integration } from "./integration"


const {
  formField: {
    integrationName, 
    description, 
    version,
  } } = integration

export const newIntegrationInitialValues = {
  [integrationName.name]: "",
  [description.name]: "",
  [version.name]: "",
}